import { render, staticRenderFns } from "./table-detail.vue?vue&type=template&id=227034ea&scoped=true"
import script from "./table-detail.vue?vue&type=script&lang=js"
export * from "./table-detail.vue?vue&type=script&lang=js"
import style0 from "./table-detail.vue?vue&type=style&index=0&id=227034ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227034ea",
  null
  
)

export default component.exports